import { Enviroment } from '../constants/enviroment-v2.constant';

const PROD_VALUES = ['master', 'production', 'prod'];

export const IsProduction = () => {
	const env = (Enviroment.ENVIRONMENT || Enviroment.DOPPLER_ENVIRONMENT || '').toLowerCase();
	if (PROD_VALUES.includes(env)) console.log = function () {};
};
